import React, { Component } from "react";
import AjaxPost from "../../components/AjaxPost/AjaxPost";
import ThankYou from "../../components/ThankYou/ThankYou";
import GA from "../../components/GA/GA";
import SmoothEvent from "../../components/SmoothAnalytics/";
import Captcha2026 from "../../components/Captcha2026/Captcha2026";
import "./Book.css";

class Book extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      email: "",
      postcode: "",
      website: "", // honeypot field — real users never fill this
      humanCheck: false,
      starttime: "7:30",
      nhours: "2",
      formOK: false,
      showThankYou: false,
      apiTimestamp: null,
      apiTimestampLoaded: null,
    };
  }

  componentDidMount(props) {
    this.props.changePage("book");
    GA("Page: Book");
    SmoothEvent("pageload");

    fetch("/api/ts")
      .then((response) => response.json())
      .then((data) => this.setState({ apiTimestampLoaded: data.ts }))
      .catch(() => this.setState({ apiTimestampLoaded: null }));
  }

  checkFormFields = () => {
    let state = this.state;
    if (state.date !== "" && state.email !== "" && state.postcode !== "" && state.humanCheck === true) {
      state.formOK = true;
    } else {
      state.formOK = false;
    }
    this.setState(state);
  };

  setValue = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    this.checkFormFields();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let that = this;
    let formData = new FormData();

    formData.append("date", this.state.date);
    formData.append("email", this.state.email);
    formData.append("postcode", this.state.postcode);
    formData.append("starttime", this.state.starttime);
    formData.append("nhours", this.state.nhours);
    formData.append("website", this.state.website);
    formData.append("ats", this.state.apiTimestamp);

    AjaxPost("/api/book", formData, function (e) {
      // console.dir( e )
      // that.clearFormValues()
      that.showThankYouMessage();
      GA("Form Submit: Book");
    });
  };

  showThankYouMessage = (e) => {
    let state = {
      showThankYou: true,
    };
    this.setState(state);
  };

  clearFormValues = (e) => {
    let cleanState = {
      date: "",
      email: "",
      postcode: "",
      starttime: "7:30",
      nhours: "1",
      formOK: false,
    };
    this.setState(cleanState);
  };

  closeThankYou = (e) => {
    let state = this.state;
    state.showThankYou = false;
    this.setState(state);
  };

  handleCaptchaActivated = (e) => {
    let state = this.state;
    state.humanCheck = true;
    state.apiTimestamp = state.apiTimestampLoaded;
    this.setState(state);
    this.checkFormFields();
  }

  render() {
    return (
      <div className="page-container">
        <div className="content-spacer-1 spacer-bg-book"></div>

        <div className="content-container">
          <div className="content-container-background"></div>

          <div className="content-container-content">
            <h1>Book a cleaner</h1>
            <br />
            Why Choose Fairy Clean?
            <br />
            <br />
            Exceptional quality service – thorough, reliable, flexible and easy to talk to!
            <br />
            <br />
            Satisfaction guaranteed – we go the extra mile to ensure your complete satisfaction
            <br />
            <br />
            Flexible booking slots – available for same day, late night, weekends and bank holidays services.
            <br />
            <br />
            <form onSubmit={this.handleSubmit}>
              <div className="floater book-postcode">
                <span className="form-label">
                  Postcode <span className="red">*</span>
                </span>
                <br />
                <input
                  type="text"
                  name="postcode"
                  value={this.state.postcode}
                  onChange={this.setValue}
                  placeholder="Postcode"
                  className="form-input book-postcode"
                />
              </div>

              <div className="floater book-email">
                <span className="form-label">
                  Email <span className="red">*</span>
                </span>
                <br />
                <input
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.setValue}
                  placeholder="Email"
                  className="form-input book-email"
                />
              </div>

              <div className="breaker"></div>

              <div className="floater">
                <span className="form-label">
                  Date <span className="red">*</span>
                </span>
                <br />
                <input
                  type="date"
                  name="date"
                  value={this.state.date}
                  onChange={this.setValue}
                  placeholder="Date"
                  className="form-input"
                />
                <br />
              </div>

              <div className="breaker"></div>

              <div className="floater book-starttime">
                <span className="form-label">
                  Start Time <span className="red">*</span>
                </span>
                <br />
                <select name="starttime" value={this.state.starttime} onChange={this.setValue} className="form-input">
                  <option value="7:00">7:00 AM</option>
                  <option value="7:30">7:30 AM</option>

                  <option value="8:00">8:00 AM</option>
                  <option value="8:30">8:30 AM</option>

                  <option value="9:00">9:00 AM</option>
                  <option value="9:30">9:30 AM</option>

                  <option value="10:00">10:00 AM</option>
                  <option value="10:30">10:30 AM</option>

                  <option value="11:00">11:00 AM</option>
                  <option value="11:30">11:30 AM</option>

                  <option value="12:00">12:00 PM</option>
                  <option value="12:30">12:30 PM</option>

                  <option value="13:00">1:00 PM</option>
                  <option value="13:30">1:30 PM</option>

                  <option value="14:00">2:00 PM</option>
                  <option value="14:30">2:30 PM</option>

                  <option value="15:00">3:00 PM</option>
                  <option value="15:30">3:30 PM</option>

                  <option value="16:00">4:00 PM</option>
                  <option value="16:30">4:30 PM</option>

                  <option value="17:00">5:00 PM</option>
                  <option value="17:30">5:30 PM</option>

                  <option value="18:00">6:00 PM</option>
                </select>
              </div>

              <div className="floater book-hours">
                <span className="form-label">
                  Hours <span className="red">*</span>
                </span>
                <br />
                <select name="nhours" value={this.state.nhours} onChange={this.setValue} className="form-input">
                  <option value="2">2 hours</option>
                  <option value="3">3 hours</option>
                  <option value="4">4 hours</option>
                  <option value="5">5 hours</option>
                  <option value="6">6 hours</option>
                  <option value="7">7 hours</option>
                  <option value="8">8 hours</option>
                </select>
              </div>

              <input
                type="text"
                name="website"
                value={this.state.website}
                onChange={this.setValue}
                autoComplete="off"
                className="form-input form-input-2"
              />

              <div className="breaker"></div>

              <Captcha2026 onActivate={this.handleCaptchaActivated} />

              <div className={this.state.formOK ? "form-info-hidden" : "form-info"}>
                Please fill in all form fields.
              </div>

              <button disabled={!this.state.formOK} className="form-input form-button">
                {" "}
                Submit{" "}
              </button>
            </form>
            <div className={this.state.showThankYou ? "fixed100" : "hidden"}>
              <ThankYou onClick={() => this.closeThankYou()} />
            </div>
            <br />
            <br />
            <div className="cleaning-tips-container">
              <div className="cleaning-tip-icon"></div>
              <i>
                Stained refrigerators will shine like new after soaking problem areas in undiluted clear distilled malt
                vinegar also vinegar is a very good limescale remover, you can use it for kettle or sink as well.
              </i>
              <div className="breaker"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Book;
